import { Link } from "react-router-dom";
import { Home, Car, ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import Seo from "@/components/Seo";

const LOGO_IMG = "/img/n148kmw9_image.webp";

const COPY = {
  cs: { title: "Stránka nenalezena", desc: "Tuhle adresu se nám nepodařilo najít. Možná byla přesunuta nebo už neexistuje.", home: "Zpět na hlavní stránku", cars: "Prohlédnout vozy" },
  en: { title: "Page not found", desc: "We couldn't find this address. It may have been moved or no longer exists.", home: "Back to homepage", cars: "Browse cars" },
  de: { title: "Seite nicht gefunden", desc: "Diese Adresse konnten wir nicht finden. Sie wurde möglicherweise verschoben oder existiert nicht mehr.", home: "Zurück zur Startseite", cars: "Fahrzeuge ansehen" },
};

const NotFound = () => {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.cs;
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center text-center px-5 relative overflow-hidden" data-testid="not-found-page">
      <Seo title="404 – Stránka nenalezena | EffectDeal" description={c.desc} />
      <div className="absolute inset-0 pointer-events-none opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 50% 30%, #f97316 0%, transparent 60%)" }} />
      <img src={LOGO_IMG} alt="EffectDeal" className="w-14 h-14 object-contain mb-8 opacity-90" />
      <p className="font-['Cabinet_Grotesk'] font-black text-7xl sm:text-8xl bg-gradient-to-b from-white to-zinc-600 bg-clip-text text-transparent leading-none">404</p>
      <h1 className="font-['Cabinet_Grotesk'] text-2xl sm:text-3xl font-bold mt-5 text-white">{c.title}</h1>
      <p className="text-zinc-400 mt-3 max-w-md text-sm sm:text-base">{c.desc}</p>
      <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
        <Link to="/" className="btn-accent inline-flex items-center gap-2" data-testid="not-found-home">
          <Home className="w-4 h-4" /> {c.home}
        </Link>
        <Link to="/#vehicles" className="btn-outline inline-flex items-center gap-2" data-testid="not-found-cars">
          <Car className="w-4 h-4" /> {c.cars}
        </Link>
      </div>
      <Link to="/" className="text-zinc-500 hover:text-white text-sm mt-10 inline-flex items-center gap-1.5 transition-colors">
        <ArrowLeft className="w-4 h-4" /> EffectDeal
      </Link>
    </div>
  );
};

export default NotFound;
